<style lang="scss" scoped>
.search-wrap {
    .search-btn {
        margin-bottom: 16px;
        border-bottom: 1px solid #2d8cf0;
        button {
            border-bottom: none;
            min-width: 120px;
        }
    }
    .search-main {
        .ivu-form-item {
            margin-bottom: 6px;
        }
        button {
            margin-left: 6px;
        }
    }
    .search-other {
        padding: 9px 16px;
        margin-bottom: 6px;
        border: 1px solid #ddd;
        background-color: #fff;
        transition: all 0.3s ease-in;
        .ivu-form-item {
            margin: 6px;
            width: 260px;
        }
    }
}
</style>
<template>
    <div>
        <div class="search-wrap searchb2c">
            <article class="search-main clearfix">
                <div class="pull-left">
                    <Button type="info" @click="handleOperates('','exportExcel')">{{$t('global.common.export', { defaultValue: "导出" })}}</Button>
                </div>
                <div class="pull-right">
                    <Form inline>
                        <Button type="primary" @click="update()" icon="ios-search">{{$t("global.common.btn_search",{defaultValue:'查询'})}}</Button>
                        <Button @click="resetdata" icon='md-refresh'>{{$t("global.common.btn_reset",{defaultValue:'重置'})}}</Button>
                    </Form>
                </div>
                <div class="pull-right">
                    <Form inline>
                        <FormItem :label="$t('fbb.inbound.client_organization', { defaultValue: '客户' })" :labelWidth="40">
                            <vSelect v-model="formData.search.EQ_organizationId" filterable clearable style="width:140px">
                                <vOption v-for="item in getNextOrgList" :value="item.value" :key="item.value">{{ item.label }}</vOption>
                            </vSelect>
                        </FormItem>
                        <FormItem :label="$t('fbb.bill.freeze_type', { defaultValue: '类型' })" :labelWidth="40">
                            <vSelect v-model="formData.search.EQ_status" filterable clearable style="width:140px">
                                <vOption value=0 >{{$t("fbb.bill.freeze_close",{defaultValue:'冻结'})}}</vOption>
                                <vOption value=1 >{{$t("fbb.bill.freeze_open",{defaultValue:'解冻'})}}</vOption>
                            </vSelect>
                        </FormItem>
                        <FormItem :label="$t('global.common.order_no', { defaultValue: '单号' })" :labelWidth="40">
                            <vInput clearable v-model.trim="formData.search.EQ_trackingNo" style="width:140px"/>
                        </FormItem>
                        <FormItem :label="$t('fbb.bill.freeze_createdat', { defaultValue: '创建日期' })" :labelWidth="65">
                            <vDatepicker v-model="formData.search.BT_createdAt" format='yy-mm-dd ~ yy-mm-dd' style="width:200px"></vDatepicker>
                        </FormItem>
                    </Form>
                </div>
            </article>
        </div>
        <div class="margin-top-10"> <span class="color-success">{{$t("fbb.bill.freeze_openno",{defaultValue:'解冻账户'})}}: {{totalUnFree}}</span><span class="color-error margin-left-10">{{$t("fbb.bill.freeze_closeno",{defaultValue:'冻结账户'})}}：{{totalFree}}</span></div>
        <vTable class="margin-top-15" :data="datalist" border stripe :columns="columnsList" :loading="loading"></vTable>
        
        <Page class="relative text-right margin-top-10 padding-bottom-50" showSizer showElevator v-bind="{total,pageSize:formData.rows,current:formData.page}" :page-size-opts="pagesizes"  @on-change='changePage' @on-page-size-change='changePageSize' show-total></Page>

        <compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-confirm="modalProps={}"
            @on-close="modalProps={}"
		>
            <vTable :data="modalProps.amountlist" border :columns="modalProps.amountColumn"></vTable>
        </compModal>
    </div>
</template>

<script>

import { HttpGetFreeze,HttpGetFreezeAmount } from "@/service/billing";
import { mapState, mapGetters } from "vuex";

export default {
	components: {
        compTablelist: () => import("@components/templates/tablelist"),
        // compSpage: () => import("@/components/boss/spage"),
        
	},
    data(){
        return {
            pagesizes:[10,20,50,100],
            formData:{
                page: 1,
                rows: 10,
                sidx: 'id',
                sord: 'desc',
                search:{
                    
                }
            },
            total:0,
            datalist:[],
            freezeaccount:0,
            unfreezeaccount:0,
            totalUnFree:0,
            totalFree:0,
            loading:false,
            modalProps:{
                show:false,
            }
        }
    },
    created(){
        this.update()
    },
    methods:{
        handleOperates(params='',type) {
            switch (type) {
                case 'exportExcel':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/funding/freeze/export', this.formData, 'download');
                    break;
                case 'amountdetail':
                    const detaillist = JSON.parse(params) 
                    this.modalProps = {
                        show:true,
                        width:500,
                        showFooter: false,
                        amountlist:detaillist,
                        amountColumn:[{
                            title:  '费用名称',
                            key: 'costName',
                        },{
                            title:  '预估费用',
                            key: 'estimatedCost',
                        },{
                            title:  '币种',
                            key: 'currency',
                        }]
                    }
                    break;
            }
        },
        update(val){
            this.loading = true
            HttpGetFreeze({...this.formData,...val}).then(res=>{
                this.$set(this.$data,'datalist',res.data.content)
                // this.datalist = res.data.content;
                this.total = res.data.totalElements;
                this.loading = false
            },err=>{
                this.loading = false
                this.$VMessage.error(err.message);
            })
            // console.log(this.formData)
            HttpGetFreezeAmount({
                'search[EQ_status]':this.formData.search.EQ_status,
                'search[EQ_trackingNo]':this.formData.search.EQ_trackingNo,
                'search[BT_createdAt]':this.formData.search.BT_createdAt,
                'search[EQ_organizationId]':this.formData.search.EQ_organizationId
            }).then(res=>{
                this.loading = false
                this.totalFree = res.data.totalFree;
                this.totalUnFree = res.data.totalUnFree;
            },err=>{
                this.loading = false
                this.$VMessage.error(err.message);
            })
        },
        resetdata(){
            let dataclear = {
                page: 1,
                rows: 10,
                sidx: 'id',
                sord: 'desc',
                search:{
                    
                    }
            };
            this.formData = dataclear
            this.update()
        },
        changePage(val) {
            this.update({ page: val });
		},
		changePageSize(val) {
            this.update({ rows: val, page: 1 });
		},
    },
    computed:{
        ...mapGetters('dictionary', ['getNextOrgList']),
        
        columnsList() {
			return [
				{
                    title:  this.$t('fbb.inbound.client_organization', { defaultValue: "客户" }),
                    key: 'organizationName',
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: "创建时间" }),
                    key: 'updatedAt',
				},
				{
                    title: this.$t('fbb.bill.freeze_type', { defaultValue: "类型" }),
                    key: 'status',
                    render:(h,{row})=>{
                        if(row.status == 0){
                            return <div>{this.$t("fbb.bill.freeze_close",{defaultValue:'冻结'})}</div>
                        } else return <div>{this.$t("fbb.bill.freeze_open",{defaultValue:'解冻'})}</div>
                    }
				},
				{
					title: "描述",
                    key: 'type',
                    render:(h,{row})=>{
                        if(row.type == 0){
                            return <div>{this.$t("fbb.bill.freeze_closeauto",{defaultValue:'自动冻结'})}</div>
                        } else return <div>{this.$t("fbb.bill.freeze_closemanual",{defaultValue:'手动冻结'})}</div>
                        
                    }
                },
                {
                    title: this.$t('fbb.bill.freeze_amount', { defaultValue: "金额(USD)" }),
                    key: 'amount',
                    render:(h,{row})=>{
                        if(row.detail){
                            return <a onClick={this.handleOperates.bind(this, row.detail, 'amountdetail')}>{row.amount}</a>
                        }else{
                            return <div>{row.amount}</div>
                        }
                    }
				},
				{
					title:  this.$t('fbb.bill.freeze_trackingno', { defaultValue: "运单号" }),
					key: 'trackingNo',
				},
                {
					title:  this.$t('global.common.notes', { defaultValue: "备注" }),
					key: 'cause',
				},
			]
		},
    }
}
</script>